<template>
  <div>
    <!-- <div style="height: 200px;"></div> -->
    <div class="footer">
    <div class="footer_cont">
      <div class="f_l">
        <div class="f3">版权所有©广材帮</div>
        
        <div class="f4">备案号：
          <a  target="_blank" href="https://beian.miit.gov.cn/#/Integrated/index">蜀ICP备2024109498号-1</a>
        </div>
      </div>
      <div class="f_r">
        <div style="margin-right:20px">
          <div class="f5">客服电话：19181377185</div>
          <div class="f5">(紧急情况勤联系客服)</div>
        </div>

        <div>
          <div style="margin-bottom:20px">客服微信</div>
          <!-- <div class="f5">关注广材帮公众号，随时随地接收消息</div> -->
          <div>
            <!-- <img src="@/assets/il.jpg" alt="" srcset=""> -->
            <img src="@/assets/ir.jpg" alt="" srcset="">
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
export default {
  name: '',
  data() {
    return {

    }
  },
  mounted() {

  },
  methods: {

  },
}
</script>
<style lang='scss' scoped>
.footer {
  width: 100%;
  height: 200px;
  background: #040B1F;
  border-radius: 0px 0px 0px 0px;
  // position: fixed;
  // bottom: 0%;
  display: flex;
  justify-content: center;
  padding: 29px 0px;
  box-sizing: border-box;

  .footer_cont {
    width: 1200px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #ADAAAA;
    line-height: 16px;
    display: flex;
    justify-content: space-between;

    .f_l {
      .f2 {
        margin-top: 10px;
        a{
          color: #ADAAAA;
          text-decoration:none
        }
        a:hover{
          color: #fff;
        }
        span{
          margin: 0 20px;
        }
      }

      .f3 {
        margin-top: 27px;
      }

      .f4 {
        margin-top: 10px;
        a{
          color: #ADAAAA;
          text-decoration:none
        }
        a:hover{
          color: #fff;
        }
      }
    }

    .f_r{
      display: flex;
      .f5{
        margin: 10px 0px 14px 0px;
      }
      img{
        width: 66px;
        height: 66px;
        margin-right: 20px;
        border-radius: 6px;
      }
    }
  }
}
</style>